import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const FETCH_REQUESTS = 'requests_accounting/FETCH_REQUESTS';
const FETCH_REQUESTS_SUCCESS = 'requests_accounting/FETCH_REQUESTS_SUCCESS';
const FETCH_REQUESTS_FAIL = 'requests_accounting/FETCH_REQUESTS_FAIL';

const SELECT_REQUEST = 'requests_manager/SELECT_REQUEST';

const APPROVE_REQUEST = 'requests_accounting/APPROVE_REQUEST';
const APPROVE_REQUEST_SUCCESS = 'requests_accounting/APPROVE_REQUEST_SUCCESS';
const APPROVE_REQUEST_FAIL = 'requests_accounting/APPROVE_REQUEST_FAIL';

const REJECTED_REQUEST = 'requests_accounting/REJECTED_REQUEST';
const REJECTED_REQUEST_SUCCESS = 'requests_accounting/REJECTED_REQUEST_SUCCESS';
const REJECTED_REQUEST_FAIL = 'requests_accounting/REJECTED_REQUEST_FAIL';

const initialState = {
  selectedRequests: [],
  requests: [],
  pageCount: 1,
  loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REQUESTS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_REQUESTS_SUCCESS:
      const selectedRequests = action.result.data.data.filter(
        request => !state.selectedRequests.some(
          r => r.group_id === request.group_id)).map((request) => {
        request.selected = true;

        return request;
      });

      return {
        ...state,
        loading: false,
        requests: (action.result.data ? action.result.data.data : []),
        selectedRequests: state.selectedRequests.length > 0
          ? state.selectedRequests.concat(selectedRequests)
          : action.result.data.data.map((request) => {
            request.selected = true;

            return request;
          }),
        pageCount: (action.result.data ? action.result.data.pageCount : 1),
      };
    case FETCH_REQUESTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data,
      };
    case SELECT_REQUEST:
      return {
        ...state,
        selectedRequests: state.selectedRequests.filter((request) => {
          if (request.group_id === action.payload.groupId) {
            request.selected = action.payload.selected;
          }

          return request;
        }),
        page: action.payload.pageCount
      };
    case APPROVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case APPROVE_REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests.filter((group) => {
          group.harcirah = group.harcirah.filter(
            harcirah => harcirah._id !== action.payload.harcirahId);

          return group.harcirah.length > 0;
        }),
        loading: false,
      };
    case APPROVE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };
    case REJECTED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REJECTED_REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests.filter((group) => {
          group.harcirah = group.harcirah.filter(
            harcirah => harcirah._id !== action.payload.harcirahId);

          return group.harcirah.length > 0;
        }),
        loading: false,
      };
    case REJECTED_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };
    default:
      return state;
  }
}

export function fetchRequests(params) {
  return {
    types: [FETCH_REQUESTS, FETCH_REQUESTS_SUCCESS, FETCH_REQUESTS_FAIL],
    promise: client => client.post('/accounting/request/lists',
      { data: {}, params }),
  };
}
export function selectRequest(selected, groupId, pageCount) {
  return {
    type: SELECT_REQUEST,
    payload: { selected, groupId, pageCount },
  };
}
export function approveRequest(payload) {
  return {
    types: [APPROVE_REQUEST, APPROVE_REQUEST_SUCCESS, APPROVE_REQUEST_FAIL],
    loading: true,
    payload,
    promise: client => client.post('/accounting/request/approve', {
      data: payload,
    }),
  };
}
export function rejectRequest(payload) {
  return {
    types: [REJECTED_REQUEST, REJECTED_REQUEST_SUCCESS, REJECTED_REQUEST_FAIL],
    loading: true,
    payload,
    promise: client => client.post('/accounting/request/rejected', {
      data: payload,
    }),
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/requests-accounting.js